export default __webpack_public_path__ + "static/media/booking-icon.7e6fa741.svg";